export default props => {
  return (
    <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 8L7 2L13 8" stroke="#041333" strokeWidth="2" />
    </svg>
  )
}
